﻿import { createContext, useContext, type ReactNode } from 'react'
import type { Sessao } from './sessao'

const Ctx = createContext<Sessao | null>(null)

export function SessaoProvider({
  valor,
  children,
}: {
  valor: Sessao | null
  children: ReactNode
}) {
  return <Ctx.Provider value={valor}>{children}</Ctx.Provider>
}

export function useSessao(): Sessao | null {
  return useContext(Ctx)
}
